import { useI18n } from "@/i18n";
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/common/PageHeader";
import { Lock } from "lucide-react";

const NAV_KEY = {
  scan: "scan", banking: "banking", purchasing: "purchasing", jobs: "jobs",
  einvoices: "einvoices", inbound: "inbound", datev: "datev",
};

function DisabledModule({ moduleKey }) {
  const { t } = useI18n();
  const navKey = NAV_KEY[moduleKey] || moduleKey;
  return (
    <div>
      <PageHeader title={t(`nav.${navKey}`)} />
      <div
        className="flex flex-col items-center justify-center rounded-lg border border-dashed border-slate-300 bg-white/50 px-6 py-20 text-center dark:border-slate-700 dark:bg-slate-900/40"
        data-testid={`module-disabled-${moduleKey}`}
      >
        <span className="mb-4 inline-flex items-center gap-2 rounded-full bg-slate-200 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-slate-600 dark:bg-slate-800 dark:text-slate-300">
          <Lock className="h-3.5 w-3.5" />
          {t("module_gate.title")}
        </span>
        <p className="mt-2 max-w-md text-sm text-slate-500 dark:text-slate-400">{t("module_gate.desc")}</p>
      </div>
    </div>
  );
}

export function ModuleGate({ module, perm, moduleKey, children }) {
  const { modules, can } = useAuth();
  const enabled = !module || (modules || []).includes(module);
  const permitted = !perm || can(perm);
  if (!enabled || !permitted) return <DisabledModule moduleKey={moduleKey || module} />;
  return children;
}
